import moment from "moment";

function parseAgGridDate(str) {
  if (str == null || str === "") return null;
  const iso = moment(str, moment.ISO_8601, true);
  if (iso.isValid()) return iso;
  const spaced = moment(String(str), "YYYY-MM-DD HH:mm:ss", true);
  if (spaced.isValid()) return spaced;
  const day = moment(String(str), "YYYY-MM-DD", true);
  if (day.isValid()) return day;
  const d = new Date(str);
  return Number.isNaN(d.getTime()) ? null : moment(d);
}

/**
 * Map AG Grid Community filter model → View Meeting API `filters` body (per status section).
 * Undefined when nothing set.
 */
export function gridFilterModelToViewMeetingFilters(model) {
  if (!model || typeof model !== "object") return undefined;

  const out = {};

  const mid = model["Meeting Id"];
  if (mid?.filter != null && String(mid.filter).trim()) {
    out.meetingIdContains = String(mid.filter).trim().slice(0, 64);
  }

  const mapDateCol = (colId, fromKey, toKey) => {
    const dm = model[colId];
    if (!dm || dm.filterType !== "date") return;
    const type = dm.type;
    const fromM = parseAgGridDate(dm.dateFrom);
    const toM = parseAgGridDate(dm.dateTo);

    if (type === "equals" && fromM) {
      out[fromKey] = fromM.clone().startOf("day").toISOString();
      out[toKey] = fromM.clone().endOf("day").toISOString();
      return;
    }
    if (type === "inRange") {
      if (fromM) out[fromKey] = fromM.clone().startOf("day").toISOString();
      if (toM) out[toKey] = toM.clone().endOf("day").toISOString();
      return;
    }
    if (type === "lessThan" && fromM) {
      out[toKey] = fromM.clone().startOf("day").subtract(1, "ms").toISOString();
      return;
    }
    if (type === "greaterThan" && fromM) {
      out[fromKey] = fromM.clone().endOf("day").add(1, "ms").toISOString();
    }
  };

  mapDateCol("Schedule Date", "scheduledDateFrom", "scheduledDateTo");
  mapDateCol("Created Date", "createdAtFrom", "createdAtTo");

  const text = (field, apiKey) => {
    const t = model[field];
    if (t?.filter != null && String(t.filter).trim()) {
      out[apiKey] = String(t.filter).trim().slice(0, 200);
    }
  };

  text("Client Name", "clientNameContains");
  text("Physician Name", "physicianNameContains");
  text("consultingField", "consultationContains");
  text("Admin comments", "commentsContains");
  text("MeetingStatus", "meetingStatusContains");

  return Object.keys(out).length ? out : undefined;
}
